import * as types from './action-types';
import playerData from '../playerData';

// gets the player data for the current pathname
export function getPlayerData(){
  let pathname = window.location.pathname;
  pathname = pathname.replace('/index.html', '');
  const pageData = playerData[0][pathname];

  // update the page title
  document.title = pageData.title + ' Powered by: Custom Channels';

  return (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_PLAYER_DATA, 
      data: pageData
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/app-actions.js